import React from "react";

export default function InOutBioBrand({ className = "", label = "Open InOutBio" }) {
    return (
        <a
            href="https://inoutbio.com"
            target="_blank"
            rel="noopener noreferrer"
            className={`inoutbio-brand ${className}`}
            aria-label={`${label} in a new tab`}
        >
            <span className="inoutbio-brand-mark" aria-hidden="true">
                <span></span>
                <span></span>
            </span>
            <span className="inoutbio-brand-wordmark" aria-hidden="true">
                <span>InOut</span>
                <span className="inoutbio-brand-accent">Bio</span>
            </span>
        </a>
    );
}
